module.exports = __webpack_public_path__ + "img/1.9a20d20c.png";